// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_f8-0";
export var optionCard = "_f8-1";